import { createTheme } from "@material-ui/core/styles";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    backgroundMainColor: Palette['primary'];
  }
  interface PaletteOptions {
    backgroundMainColor?: PaletteOptions['primary'];
  }
  interface PaletteColor {
    secondary?: string;
  }
  interface SimplePaletteColorOptions {
    secondary?: string;
  }
}

export const lightTheme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#007438",
      secondary: "#0E5C54",
    },
    secondary: {
      main: "#E33E7F",
    },
    background: {
      default: "#000000",
      paper: "#ffffff",
    },
    text: {
      primary: "#000000",
      secondary: "#666666",
    },
    backgroundMainColor: {
      main: "#033B57",
    },
  },
  typography: {
    fontFamily: '"Heebo", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          background: "linear-gradient(180deg, #003D5C 0%, #003551 50%, #002234 75%, #000305 88%, #000000 100%)",
          backgroundAttachment: "fixed",
          minHeight: "100vh",
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: 45,
      },
    },
    MuiButtonGroup: {
      grouped: {
        "&:not(:first-child)": {
          borderRadius: 0,
        },
        "&:not(:last-child)": {
          borderRadius: 0,
        },
      },
    },
    MuiAppBar: {
      root: {
        background: "linear-gradient(to top, rgba(0, 61, 92, 0) 0%, rgba(0, 61, 92, 1) 100%) !important",
        backdropFilter: "blur(15px)",
        WebkitBackdropFilter: "blur(15px)",
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: "#ffffff",
        borderRadius: 8,
        "& fieldset": {
          borderColor: "#cccccc",
          borderRadius: 8,
        },
        "&:hover fieldset": {
          borderColor: "#007438",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#007438",

        },
      },
      input: {
        backgroundColor: "transparent",
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: (props) => "#ffffff",
        borderRadius: 8,
        "&:hover": {
          backgroundColor: (props) => "#ffffff",
        },
        "&.Mui-focused": {
          backgroundColor: (props) => "#ffffff",

        },
      },
      input: {
        backgroundColor: "transparent",
        color: (props) => "#000000",
      },
    },
    MuiLink: {
      root: {
        color: "#218B84",
      },
    },
    MuiListItem: {
      root: {
        backgroundColor: (props) => "#ffffff",
        color: (props) => "#000000",
        "& .MuiTypography-root": {
          color: (props) => "#000000",
        },
        "& .MuiListItemIcon-root": {
          color: (props) => "#000000",
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        color: "#ffffff",
      },
    },
    MuiSwitch: {
      switchBase: {
        color: (props) => "#cccccc",
      },
      track: {
        backgroundColor: (props) => "#999999",
        opacity: 1,
      },
    },
    MuiPaper: {
      root: {
        "&.MuiDataGrid-root": {
          backgroundColor: "#ffffff",
        },
      },
    },
    MuiTypography: {
      root: {
        color: "#ffffff",
      },
    },
  },
  props: {
    MuiTablePagination: {
      labelRowsPerPage: "Rivejä yhteensä",
      labelDisplayedRows: ({ from, to, count }) => `${from}-${to} / ${count}`,
    },
  },
});
